export function getPathTemplate(
  pathname: string,
  params: Record<string, string | undefined>,
) {
  return Object.entries(params).reduce((template, [key, value]) => {
    if (!value) return template;
    return template.split(value).join(`:${key}`);
  }, pathname);
}
